import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { FormEvent, ReactElement } from 'react';
import { ButtonWithLoader } from '../../../../design/buttons/ButtonWithLoader';
import { S_Modal } from '../../../../design/modals/modal/S_Modal';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { InputStatus } from '../../../models/error.model';
import { PasswordWithScoreInputsContainer } from '../../auth/containers/PasswordWithScoreInputsContainer';

interface IChangePasswordModal {
  showPasswordModal: boolean;
  oldPasswordStatus: InputStatus;
  passwordFormIsValid: boolean;
  onConfirm: () => Promise<void>;
  onCancel: () => void;
  onNewPasswordChange: (password: string) => void;
  onNewPasswordStatusChange: (passwordStatus: InputStatus) => void;
  onOldPasswordChange: (password: string) => void;
  onOldPasswordBlur: () => void;
}

export const ResetPasswordModal = observer((props: IChangePasswordModal): ReactElement => {
  const { t } = useTranslator();

  const handleSubmit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    await props.onConfirm();
  };

  return (
    <S_Modal
      isOpen={props.showPasswordModal}
      toggle={props.onCancel}
      headerText={t('change_password')}
      buttons={
        <>
          <Button
            color='neutral'
            variant='outlined'
            onClick={props.onCancel}
          >
            {t('cancel')}
          </Button>
          <ButtonWithLoader
            disabled={!props.passwordFormIsValid}
            loaderKey='change_password_loader'
            onClick={handleSubmit}
          >
            {t('change')}
          </ButtonWithLoader>
        </>
      }
    >
      <ValidatedTextInput
        labelText={t('old_password')}
        isRequired
        type='password'
        placeholder={t('enter_old_password')}
        enablePreview={true}
        isValid={props.oldPasswordStatus.isValid}
        feedbacks={props.oldPasswordStatus.errorCodes}
        onChange={props.onOldPasswordChange}
        onBlur={props.onOldPasswordBlur}
        autoComplete='one-time-code'
      />
      <PasswordWithScoreInputsContainer
        labelText={t('new_password')}
        onPasswordChange={props.onNewPasswordChange}
        onPasswordStatusChange={props.onNewPasswordStatusChange}
        autoComplete='one-time-code'
      />
    </S_Modal>
  );
});
